/** Prefix for links when a 2-letter region is active, e.g. /gb */
export function pathWithRegion(path, region) {
  const p = path.startsWith('/') ? path : `/${path}`;
  if (!region || !/^[a-z]{2}$/.test(String(region).toLowerCase())) return p;
  if (p === '/') return `/${region}`;
  return `/${region}${p}`;
}
